module.exports = __webpack_public_path__ + "static/media/11.9eced3e3.JPG";